module.exports = __webpack_public_path__ + "media/images/home/studenti01-123bd736b32fb496a992b4f6bfe615a6.svg";